import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/team-up-everyday',
    name: 'gameLanding',
    component: () => import(/* webpackChunkName: "gameLanding" */ '../views/GameLanding.vue'),
  },
  {
    path: '/team-up-everyday/play',
    name: 'game',
    component: () => import(/* webpackChunkName: "game" */ '../views/Game.vue'),
  },
  {
    path: '/team-up-for-youth',
    name: 'teamUpForYouth',
    component: () => import(/* webpackChunkName: "teamUpForYouth" */ '../views/TeamUpForYouth.vue'),
  },
  {
    path: '/team-up-for-youth/category/:code',
    name: 'teamUpForYouthDetail',
    component: () => import(/* webpackChunkName: "teamUpForYouthDetail" */ '../views/TeamUpForYouthDetail.vue'),
  },
  {
    path: '/email/unsubscribe',
    name: 'unsubscribe',
    component: () => import(/* webpackChunkName: "unsubscribe" */ '../views/Unsubscribe.vue'),
  },
  // {
  //   path: '/game',
  //   name: 'game',
  //   component: () => import(/* webpackChunkName: "game" */ '../views/Game.vue'),
  // },
  {
    path: '/issue/ruang-tengah-14',
    name: 'publication',
    component: () => import(/* webpackChunkName: "issue" */ '../views/PubDetail.vue'),
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import(/* webpackChunkName: "blog" */ '../views/Blog.vue'),
  },
  {
    path: '/untukmubumiku',
    name: 'untukmubumiku',
    component: () => import(/* webpackChunkName: "untukmubumiku" */ '../views/Feed.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
  },
  {
    path: '/term-of-use',
    name: 'term',
    component: () => import(/* webpackChunkName: "term" */ '../views/Term.vue'),
  },
  {
    path: '/user/change-pwd',
    name: 'changePwd',
    component: () => import(/* webpackChunkName: "changePwd" */ '../views/ChangePwd.vue'),
  },
  {
    path: '/dbs',
    name: 'registerDbs',
    component: () => import(/* webpackChunkName: "registerDbs" */ '../views/RegisterDbs.vue'),
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { app }: any = router;
  next();
});

export default router;
